export const AUTHENTICATED_GUEST_FALLBACK_MESSAGE =
  "This signed-in account cannot access the meeting. You can join using the guest link."

const AUTHENTICATED_GUEST_FALLBACK_STATUS_CODES = new Set([401, 403, 404])

export const isAuthenticatedGuestFallbackError = (error: any) => {
  const status = Number(error?.response?.status)
  return AUTHENTICATED_GUEST_FALLBACK_STATUS_CODES.has(status)
}

export const hasMeetingQuestionCollectionEnded = (meeting: { end_time?: string | null } | null) => {
  if (!meeting?.end_time) return false
  const endTime = new Date(meeting.end_time).getTime()
  if (Number.isNaN(endTime)) return false
  return endTime <= Date.now()
}
